import createClient from '../../apolloClient';
import ESIM_QUERY from '../../query/esim';

const fetchEsim = async (variables, key) => {
  const client = createClient();
  const result = await client.query({
    query: ESIM_QUERY(key),
    variables,
  });
  const { esim } = result?.data || {};
  return esim;
};

export default fetchEsim;
